import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Axios from 'axios';
import { RawConfig } from './contexts/auth';

window.healthAuth = {
	isAuthenticated: !!window.localStorage.getItem('id_token'),
};

Axios.defaults.baseURL = RawConfig.base_url_api;

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
